import { forwardRef, type TextareaHTMLAttributes } from "react";
import {
  GdRichTextEditableSurface,
  type GdRichTextInsertHandle,
  type GdRichTextVariant,
} from "@/components/ui/GdRichTextContentEditable";

export type { GdRichTextInsertHandle, GdRichTextVariant };

type GdRichTextareaProps = Omit<
  TextareaHTMLAttributes<HTMLTextAreaElement>,
  "rows" | "value" | "onChange"
> & {
  minRows?: number;
  value?: string;
  onChange?: (event: { target: { value: string } }) => void;
  variant?: GdRichTextVariant;
};

export const GdRichTextarea = forwardRef<GdRichTextInsertHandle, GdRichTextareaProps>(
  function GdRichTextarea(
    { value, onChange, className, minRows = 2, disabled, placeholder, id, variant, ...rest },
    ref,
  ) {
    return (
      <GdRichTextEditableSurface
        ref={ref}
        value={value}
        onChange={(next) => {
          onChange?.({ target: { value: next } });
        }}
        disabled={disabled}
        multiline
        minRows={minRows}
        className={className}
        placeholder={placeholder}
        id={id}
        variant={variant}
        aria-label={rest["aria-label"]}
      />
    );
  },
);

export function GdDocumentLangtextField({
  label,
  value,
  onChange,
  disabled,
  minRows = 6,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  minRows?: number;
}) {
  return (
    <label className="block space-y-1 text-sm">
      <span className="text-label-secondary">{label}</span>
      <GdRichTextarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        minRows={minRows}
        variant="documentLangtext"
      />
      <span className="block text-xs text-label-tertiary">
        Feldbreite wie die Beschreibungsspalte im Dokument — der Umbruch entspricht dem PDF.
      </span>
    </label>
  );
}
